import {__} from "@wordpress/i18n";
import { decodeEntities } from "@wordpress/html-entities";
import { getSetting } from '@woocommerce/settings';

let _log_nonce = '';

export function set_log_nonce(nonce) {
    _log_nonce = nonce || '';
}

export function log_paysafe_error(log_error_endpoint, message, context) {
    if (log_error_endpoint) {
        const endpoint = new URL(log_error_endpoint, window.location.origin);

        if (endpoint.origin !== window.location.origin) {
            return;
        }

        fetch(
            // nosemgrep
            endpoint.pathname + endpoint.search,
            {
                method: 'POST',
                credentials: 'same-origin',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
                body: JSON.stringify({
                    message: message,
                    context: context,
                    nonce: _log_nonce,
                }),
            })
            .catch(() => {});
    }
}

export function get_paysafe_label(title, icon_url) {
    const label = decodeEntities( title ) || __('Paysafe Checkout', 'paysafe-checkout' )

    return (
        <div className={'paysafe-gateway-title'}>
            <span>{ label }</span>
            <img
                className={'paysafe-gateway-image'}
                src={ icon_url }
                alt={ label }
            />
        </div>
    );
}

export function get_paysafe_express_label() {
    const label = __('Paysafe Express Payment', 'paysafe-checkout' )

    return (
        <div className={'paysafe-gateway-title'}>
            <span>{ label }</span>
        </div>
    );
}

export function show_paysafe_checkout_error(error_message, dont_clear_messages) {
    dont_clear_messages = !!dont_clear_messages;

    let woo_errors = document.getElementsByClassName('woocommerce-error');
    woo_errors = woo_errors.length > 0 ? woo_errors[0] : null;

    if (!woo_errors) {
        let notice_wrappers = document.getElementsByClassName('woocommerce-notices-wrapper');
        let notice_wrapper = notice_wrappers.length > 0 ? notice_wrappers[0] : null;
        if (notice_wrapper) {
            woo_errors = document.createElement('ul');
            woo_errors.className = 'woocommerce-error';

            notice_wrapper.appendChild(woo_errors);
        }
    }

    if (woo_errors) {
        let error_li = document.createElement('li');


        // Normalize simple <br> markup to line breaks to avoid HTML injection
        let safeMessage = (error_message || '').replace(/<br\s*\/?>/gi, '\n');

        if (!error_li || dont_clear_messages) {
            error_li.setAttribute('id', 'paysafe-fatal-error-message');
            error_li.textContent = safeMessage;
            woo_errors.appendChild(error_li);
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
        } else {
            error_li.textContent = safeMessage;
        }
    }
}

export function main_paysafe_checkout_success_handler(
    response,
    current_cart_data,
    settings,
    options,
    is_hosted_implementation,
    emitResponse
) {
    if (typeof(options) === "undefined") {
        options = {};
    }
    if (typeof(options.settings) === "undefined") {
        options.settings = {};
    }
    is_hosted_implementation = !!is_hosted_implementation;

    let order_id = response && response.orderId;
    if (!order_id) {
        order_id = response && response.processingResponse && response.processingResponse.paymentDetails && response.processingResponse.paymentDetails.order_id ? response.processingResponse.paymentDetails.order_id : 0;
    }

    const customer_single_use_token = response && response.processingResponse && response.processingResponse.paymentDetails && response.processingResponse.paymentDetails.single_use_token ? response.processingResponse.paymentDetails.single_use_token : '';
    const merch_ref_num = response && response.processingResponse && response.processingResponse.paymentDetails && response.processingResponse.paymentDetails.merch_ref_num ? response.processingResponse.paymentDetails.merch_ref_num : '';
    const log_order_fail_endpoint = settings.log_order_fail_endpoint || null;
    const log_error_endpoint = settings.log_errors === true ? (settings.log_error_endpoint || null) : null;

    const payment_amount = parseInt(current_cart_data.cartTotals.total_price);

    if (order_id && payment_amount) {
        let currency_code = current_cart_data.cartTotals.currency_code;

        const customer = {
            firstName: current_cart_data.billingAddress.first_name,
            lastName: current_cart_data.billingAddress.last_name,
            email: current_cart_data.billingAddress.email,
        }
        const billing_address = {
            billing_street: current_cart_data.billingAddress.address_1,
            billing_street2: current_cart_data.billingAddress.address_2,
            billing_city: current_cart_data.billingAddress.city,
            billing_zip: current_cart_data.billingAddress.postcode,
            billing_state: current_cart_data.billingAddress.state,
            billing_country: current_cart_data.billingAddress.country,
            billing_phone: options && options.additional && options.additional.phone
                ? options.additional.phone : (current_cart_data.billingAddress.phone || ''),
        };

        if (is_hosted_implementation) {
            handle_paysafe_hosted_block(
                settings,
                options,
                order_id,
                customer_single_use_token,
                merch_ref_num,
                payment_amount,
                currency_code,
                customer,
                billing_address
            );
        } else {
            handle_paysafe_checkout_block(
                settings,
                options,
                order_id,
                customer_single_use_token,
                merch_ref_num,
                payment_amount,
                currency_code,
                customer,
                billing_address
            );
        }
    } else {
        if (order_id) {
            log_order_payment_failure(
                log_order_fail_endpoint,
                order_id,
                __("Payment amount missing", "paysafe-checkout"),
            );
        }

        log_paysafe_error(log_error_endpoint, __("The payment process failed. Please close this popup and try again", "paysafe-checkout"), []);

        return {
            type: emitResponse.responseTypes.ERROR,
            message: __("The payment process failed. Please close this popup and try again", "paysafe-checkout"),
        }
    }

    return response;
}

export function resolve_paysafe_payment_description(settings, addon_description = '') {
    let descriptionForDisplay = [
        <div>{ decodeEntities( settings.description || '' ) }</div>
    ];

    if (settings.description && settings.test_mode) {
        descriptionForDisplay.push(<hr></hr>);
    }

    if( settings.test_mode) {
        descriptionForDisplay.push(
            <div style={{textAlign: "justify", marginTop: "10px"}}>
                <span>{__('Paysafe Checkout is in TEST mode. Use the built-in simulator to test payments.', 'paysafe-checkout')}</span>
            </div>
        );
    }

    if (addon_description) {
        descriptionForDisplay.push(addon_description);
    }

    return descriptionForDisplay;
}

export function resolve_paysafe_express_payment_description(settings, addon_description = '') {
    let descriptionForDisplay = [
        <div>{ decodeEntities( __('Easy and secure payments with Paysafe', 'paysafe-checkout') ) }</div>
    ];

    if( settings.test_mode ) {
        descriptionForDisplay.push(<hr></hr>);
        descriptionForDisplay.push(
            <div style={{textAlign: "justify", marginTop: "10px"}}>
                <span>{__('Paysafe Checkout is in TEST mode. Use the built-in simulator to test payments.', 'paysafe-checkout')}</span>
            </div>
        );
        descriptionForDisplay.push(<p></p>);
    }

    if (addon_description) {
        descriptionForDisplay.push(addon_description);
    }

    return descriptionForDisplay;
}


export function validate_paysafe_safe_path(endpoint) {
    const validated_endpoint = new URL(endpoint, window.location.href);

    if (validated_endpoint.origin !== window.location.origin) {
        show_paysafe_checkout_error(__('Blocked non-same-origin endpoint', "paysafe-checkout") + " " + validated_endpoint.toString());
        return;
    }

    return validated_endpoint.pathname + validated_endpoint.search + validated_endpoint.hash;
}

export function get_paysafe_js_setup_error_context(
    error,
    settings,
    paysafe_options,
    current_cart_data
) {
    return {
        'error_code': error && error.code ? error.code : 0,
        'error_message': error && error.message ? error.message : '',
        'display_message': error && error.displayMessage ? error.displayMessage : '',
        'detailed_message': error && error.detailedMessage ? error.detailedMessage : '',
        'correlationId': error && error.correlationId ? error.correlationId : '-',
        'store_currency': settings && settings.currency_code ? settings.currency_code : '-',
        'cart_currency': current_cart_data
            && current_cart_data.cartTotals
            && current_cart_data.cartTotals.currency_code
            ? current_cart_data.cartTotals.currency_code : '-',
        'account_ids': paysafe_options && paysafe_options.accounts ? paysafe_options.accounts : {},
        'wp_version': getSetting( 'wpVersion', '' ),
        'woo_version': getSetting( 'wcVersion', '' ),
        'paysafe_version': settings && settings.paysafe_version ? settings.paysafe_version : '-',
    }
}

export function handle_paysafe_js_setup_error(
    error,
    settings,
    paysafe_options,
    current_cart_data,
    is_button_clicked,
    onError,
    onClose
) {
    if (error.error) {
        error = error.error;
    }

    const log_error_endpoint = settings.log_errors === true ? (settings.log_error_endpoint || null) : null;

    let error_message = ('ERROR ' + error.code + (error.detailedMessage ? ': ' + error.detailedMessage : (error.message ? error.message :"")));
    if (error.displayMessage) {
        error_message = error.displayMessage + (error.detailedMessage ? ': ' + error.detailedMessage : "");
    }

    const error_context = get_paysafe_js_setup_error_context(
        error,
        settings,
        paysafe_options,
        current_cart_data
    );
    log_paysafe_error(log_error_endpoint, error_message, error_context);

    if (error.detailedMessage && error.detailedMessage.includes('User aborted payment')) {
        onClose();
    } else {
        if (is_button_clicked) {
            onError(error_message);
        } else {
            onError(__('Error! Unable to set up Express Checkout at this moment. Please, try again later.', "paysafe-checkout") + (error.code ? ' (' + error.code + ')' : ""));
        }
    }
}

export function handle_express_payment_click(
    payment_method,
    settings,
    current_cart_data,
    hostedInstance,
    onError,
    onClose
) {
    const log_error_endpoint = settings.log_errors === true ? (settings.log_error_endpoint || null) : null;
    const payment_method_name = payment_method === 'GOOGLEPAY' ? 'google_pay' : 'apple_pay';

    // disable the express checkout block,
    // payment process started
    const payment_amount = parseInt(current_cart_data.cartTotals.total_price);
    if (!payment_amount) {
        log_paysafe_error(log_error_endpoint, "ERROR: Express checkout order amount is not set", []);
        onError(__("ERROR: Express checkout order amount is not set", "paysafe-checkout"));
        return;
    }

    let billing_street = '';
    let billing_city = '';
    let billing_zip = '';
    let billing_state = '';
    let billing_country = '';

    if (current_cart_data && current_cart_data.billingAddress && current_cart_data.billingAddress.postcode) {
        billing_street = current_cart_data.billingAddress.address_1;
        billing_city = current_cart_data.billingAddress.city;
        billing_zip = current_cart_data.billingAddress.postcode;
        billing_state = current_cart_data.billingAddress.state;
        billing_country = current_cart_data.billingAddress.country;
    }

    const currency_code = current_cart_data.cartTotals.currency_code;
    const merchant_ref_num = settings.express_merchant_ref_num || payment_method_name + '_' + Date.now();
    const hostedTokenizationOptions = {
        transactionSource: 'WooCommerceJs',
        amount: payment_amount,
        transactionType: 'PAYMENT',
        currency: currency_code,
        merchantRefNum: merchant_ref_num,
        environment: settings.test_mode ? 'TEST' : 'LIVE',
        paymentType: payment_method,
        accountId: settings.account_id,
    };

    if (payment_method === 'APPLEPAY') {
        hostedTokenizationOptions.applePay = {
            requiredBillingContactFields: ['name', 'phone', 'email', 'postalAddress'],
            requiredShippingContactFields: ['name', 'phone', 'email', 'postalAddress'],
        };
        if (settings.apple_pay_issuer_country) {
            hostedTokenizationOptions.applePay.country = settings.apple_pay_issuer_country;
        }
    }
    if (payment_method === 'GOOGLEPAY') {
        hostedTokenizationOptions.googlePay = {
            requiredBillingContactFields: ['name', 'phone', 'email', 'postalAddress'],
            requiredShippingContactFields: ['name', 'phone', 'email', 'postalAddress'],
        };
        hostedTokenizationOptions.threeDs = {
            merchantUrl: settings.checkout_url,
            deviceChannel: "BROWSER",
            messageCategory: "PAYMENT",
            authenticationPurpose: "PAYMENT_TRANSACTION",
            transactionIntent: "GOODS_OR_SERVICE_PURCHASE",
        };
        if (settings.google_pay_issuer_country) {
            hostedTokenizationOptions.googlePay.country = settings.google_pay_issuer_country;
        }
    }

    if (billing_country && billing_zip && billing_street && billing_city && billing_state) {
        hostedTokenizationOptions.customerDetails = {
            billingDetails: {
                country: billing_country,
                zip: billing_zip,
                street: billing_street,
                city: billing_city,
                state: billing_state,
            },
        };
    }

    hostedInstance
        .tokenize(hostedTokenizationOptions)
        .then(result => {
            const paymentToken = result.token || null;
            if (!paymentToken) {
                const error_message = __("ERROR: Express checkout couldn't tokenize the payment information", "paysafe-checkout");

                log_paysafe_error(log_error_endpoint, error_message, []);
                onError(error_message);
                return;
            }

            const express_checkout_payload = {
                gateway_id: payment_method_name,
                nonce: settings.nonce,
            };

            // create the order
            const safe_path = validate_paysafe_safe_path(settings.express_checkout_endpoint);
            fetch(
                safe_path,
                {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                    }),
                    body: JSON.stringify(express_checkout_payload),
                })
                .then(result => {
                    return result.json();
                })
                .then(json => {
                    if (json.status === 'success') {
                        const orderId = json.order_id || null;
                        if (!orderId) {
                            log_paysafe_error(log_error_endpoint, "ERROR: Express checkout couldn't create Order", []);
                            onError(__("ERROR: Express checkout couldn't create the order", "paysafe-checkout"));
                            return;
                        }

                        // send the token to the BE to process the payment
                        // add AJAX code to send token to your merchant server
                        const paymentData = {
                            orderId: orderId,
                            paymentMethod: payment_method,
                            transactionType: 'PAYMENT',
                            paymentHandleToken: paymentToken,
                            amount: payment_amount,
                            customerOperation: '',
                            merchantRefNum: merchant_ref_num,
                            nonce: settings.nonce,
                        };

                        const safe_path = validate_paysafe_safe_path(settings.register_url);
                        fetch(
                            safe_path,
                            {
                                method: 'POST',
                                credentials: 'same-origin',
                                headers: new Headers({
                                    'Content-Type': 'application/json',
                                }),
                                body: JSON.stringify(paymentData),
                            })
                            .then(result => {
                                return result.json();
                            })
                            .then(json => {
                                if (json.status === 'success') {
                                    // close the Express Checkout popup
                                    hostedInstance.complete('success');
                                } else {
                                    onError("ERROR: Express checkout payment failed" + (json.message ? " (" + json.message + ")" : ""));

                                    hostedInstance.complete('fail');
                                }

                                window.location = json.redirect_url;
                            })
                            .catch((error) => {
                                // the BE call failed
                                const error_message = 'ERROR ' + error.code + ': ' + error.detailedMessage;

                                log_paysafe_error(log_error_endpoint, error_message, []);
                                onError(error_message);

                                hostedInstance.complete('fail');
                            });
                    } else {
                        onError(__("ERROR: Express checkout couldn't create the order", "paysafe-checkout"));
                    }
                })
                .catch((error) => {
                    // the BE call failed
                    const error_message = 'ERROR ' + error.code + ': ' + error.detailedMessage;

                    log_paysafe_error(log_error_endpoint, error_message, []);
                    onError(error_message);

                    hostedInstance.complete('fail');
                });
        })
        .catch(error => {
            // display the tokenization error in dialog window
            let error_message = ('ERROR ' + error.code + (error.detailedMessage ? ': ' + error.detailedMessage : ""));
            if (error.displayMessage) {
                error_message = error.displayMessage + (error.detailedMessage ? ': ' + error.detailedMessage : "");
            }

            log_paysafe_error(log_error_endpoint, error_message, []);

            if (error.detailedMessage && error.detailedMessage.includes('User aborted payment')) {
                onClose();
            } else {
                onError(error_message);
            }
        });
}

export function handle_paysafe_checkout_block(
    settings,
    options,
    order_id,
    customer_single_use_token,
    merch_ref_num,
    payment_amount,
    currency_code,
    customer,
    billing_address
) {
    const log_order_fail_endpoint = settings.log_order_fail_endpoint || null;
    const log_error_endpoint = settings.log_errors === true ? (settings.log_error_endpoint || null) : null;

    const checkout_options = {
        transactionSource: typeof(options.transactionSource) === 'undefined' ? 'WooCommerceCheckout' : options.transactionSource,
        amount: payment_amount,
        transactionType: 'PAYMENT',
        currency: currency_code,
        merchantRefNum: merch_ref_num,
        environment: settings.test_mode ? 'TEST' : 'LIVE',
        displayPaymentMethods: options.displayPaymentMethods,
        paymentMethodDetails: options.paymentMethodDetails,
        threeDs: {
            merchantUrl: settings.checkout_url,
            deviceChannel: "BROWSER",
            messageCategory: "PAYMENT",
            authenticationPurpose: "PAYMENT_TRANSACTION",
            transactionIntent: "GOODS_OR_SERVICE_PURCHASE",
        },
        locale: settings.locale,
    };

    if (settings.merchant_descriptor && settings.merchant_phone) {
        checkout_options.merchantDescriptor = {
            dynamicDescriptor: settings.merchant_descriptor,
            phone: settings.merchant_phone,
        }
    }

    if (customer_single_use_token) {
        checkout_options.singleUseCustomerToken = customer_single_use_token;
        if (options.customer) {
            checkout_options.customer = options.customer;
        }
    }
    if (!customer_single_use_token || options.settings.add_customer_when_single_use_token) {
        if (options.customer) {
            checkout_options.customer = options.customer;
        } else {
            checkout_options.customer = customer;
        }
    }
    if (!customer_single_use_token || options.settings.add_billing_when_single_use_token) {
        checkout_options.billingAddress = {
            nickName: "Home",
            zip: billing_address.billing_zip,
            country: billing_address.billing_country,
        };
        if (billing_address.billing_street) {
            checkout_options.billingAddress.street = billing_address.billing_street;
        }
        if (billing_address.billing_street2) {
            checkout_options.billingAddress.street2 = billing_address.billing_street2;
        }
        if (billing_address.billing_city) {
            checkout_options.billingAddress.city = billing_address.billing_city;
        }
        if (billing_address.billing_state) {
            checkout_options.billingAddress.state = billing_address.billing_state;
        }
        if (billing_address.billing_phone) {
            checkout_options.billingAddress.phone = billing_address.billing_phone;
        }
    }
    if (!!options.settings.use_external_simulator && settings.test_mode) {
        checkout_options.simulator = 'EXTERNAL';
    }

    if (options.shippingAddress) {
        checkout_options.shippingAddress = options.shippingAddress;
    }

    let next_page = null;

    paysafe.checkout.setup(
        settings.authorization,
        checkout_options,

        // resultCallback
        function (instance, error, result) {
            if (result && result.paymentHandleToken) {
                // Successfully Tokenized transaction, use result.paymentHandleToken to process a payment
                // add AJAX code to send token to your merchant server

                const paymentData = {
                    orderId: order_id,
                    paymentMethod: result.paymentMethod,
                    transactionType: result.transactionType,
                    paymentHandleToken: result.paymentHandleToken,
                    amount: result.amount,
                    customerOperation: result.customerOperation,
                    merchantRefNum: checkout_options.merchantRefNum,
                    nonce: settings.nonce,
                };

                const safe_path = validate_paysafe_safe_path(settings.register_url);
                fetch(
                    safe_path,
                    {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: new Headers({
                            'Content-Type': 'application/json',
                        }),
                        body: JSON.stringify(paymentData),
                    })
                    .then(result => {
                        return result.json();
                    })
                    .then(json => {
                        if (json.status === 'success') {
                            instance.showSuccessScreen(__("Your goods are now purchased. Expect them to be delivered in next 5 business days.", "paysafe-checkout"));
                        } else {
                            log_paysafe_error(log_error_endpoint, __("Payment failed. Showing failure screen.", "paysafe-checkout"), json);
                            instance.showFailureScreen(__("The payment process failed. Please close this popup and try again", "paysafe-checkout"));
                        }

                        next_page = json.redirect_url;
                    })
                    .catch((error) => {
                        let errorMessage = get_paysafe_error_message(error);

                        // log payment fail
                        log_order_payment_failure(
                            log_order_fail_endpoint,
                            order_id,
                            errorMessage
                        );

                        // the BE call failed
                        log_paysafe_error(log_error_endpoint, __("The payment process failed. Please close this popup and try again", "paysafe-checkout"), []);
                        instance.showFailureScreen(__("The payment process failed. Please close this popup and try again", "paysafe-checkout"));
                    });
            } else {
                let errorMessage = get_paysafe_error_message(error);

                // log payment fail
                log_order_payment_failure(
                    log_order_fail_endpoint,
                    order_id,
                    errorMessage
                );

                // Tokenization failed and Payment Handled moved to failed Status
                if (instance) {
                    log_paysafe_error(log_error_endpoint, __("Payment failed. Showing failure screen.", "paysafe-checkout") + ' ' + errorMessage, {'pace': 3});
                    instance.showFailureScreen(__("The payment was declined. Please, try again with the same or another payment method." + ' ' + errorMessage, "paysafe-checkout"));
                } else {
                    let master_error = __('The payment was declined. Please, try again with the same or another payment method.', "paysafe-checkout");
                    if (error && error.code && error.detailedMessage) {
                        master_error += "<br />" + ' ' + error.code + ' ' + error.detailedMessage;
                    }

                    log_paysafe_error(log_error_endpoint, master_error, []);
                    show_paysafe_checkout_error(master_error);
                }
            }
        },

        // closeCallback
        function (stage, expired) {
            if (stage) {
                // Depeding upon the stage take different actions
                switch (stage) {
                    case "PAYMENT_HANDLE_NOT_CREATED" :
                        // don't show any errors,
                        // as the customer choose to close the popup window
                        log_paysafe_error(log_error_endpoint, __('Payment failed. Popup was closed without a correct end message!', 'paysafe-checkout'), {'stage': stage, 'expired': expired});

                        window.location.reload();
                        break;

                    case "PAYMENT_HANDLE_CREATED" :
                    case "PAYMENT_HANDLE_REDIRECT" :
                    case "PAYMENT_HANDLE_PAYABLE" :
                        // in all these cases the user closed the popup after the payment
                        if (null !== next_page) {
                            window.location = next_page;
                            return;
                        }

                        // reload the cart page, something must have happened
                        window.location.reload();
                        break;

                    default:
                }
            } else {
                let errorMessage = '';
                if (!!expired) {
                    errorMessage = __('Payment session expired', 'paysafe-checkout');
                } else {
                    errorMessage = stage;
                }

                // log payment fail
                log_order_payment_failure(
                    log_order_fail_endpoint,
                    order_id,
                    errorMessage
                );

                // Add action in case Checkout is expired
                // the popup expired,
                // lets reload the page so that the customer
                // can try another payment option
                log_paysafe_error(log_error_endpoint, __('Payment failed. Showing failure screen.', 'paysafe-checkout'), {'stage': stage, 'expired': expired})
                window.location.reload();
            }
        },

        // riskCallback
        function (instance, amount, paymentMethod) {
            if (amount === payment_amount) {
                instance.accept();
            } else {
                let errorMessage = __('Payment amount risk assessment failed', 'paysafe-checkout');

                // log payment fail
                log_order_payment_failure(
                    log_order_fail_endpoint,
                    order_id,
                    errorMessage
                );

                log_paysafe_error(log_error_endpoint, __("Amount is not the value expected", "paysafe-checkout"), []);
                instance.decline(__("Amount is not the value expected", "paysafe-checkout"));
            }
        }
    );
}

export function handle_paysafe_hosted_block(
    settings,
    options,
    order_id,
    customer_single_use_token,
    merch_ref_num,
    payment_amount,
    currency_code,
    customer,
    billing_address
) {
    const log_order_fail_endpoint = settings.log_order_fail_endpoint || null;
    const log_error_endpoint = settings.log_errors === true ? (settings.log_error_endpoint || null) : null;

    if (typeof(options.hosted_payment_instance) === "undefined") {
        // log payment fail
        log_order_payment_failure(
            log_order_fail_endpoint,
            order_id,
            __("Hosted payment instance is not set", "paysafe-checkout")
        );

        return;
    }
    const hostedPaymentInstance = options.hosted_payment_instance;

    const tokenizationOptions = {
        transactionSource: typeof(options.transactionSource) === 'undefined' ? 'WooCommerceJs' : options.transactionSource,
        amount: payment_amount,
        transactionType: 'PAYMENT',
        currency: currency_code,
        merchantRefNum: merch_ref_num,
        environment: settings.test_mode ? 'TEST' : 'LIVE',
        threeDs: {
            merchantUrl: settings.checkout_url,
            deviceChannel: "BROWSER",
            messageCategory: "PAYMENT",
            authenticationPurpose: "PAYMENT_TRANSACTION",
            transactionIntent: "GOODS_OR_SERVICE_PURCHASE",
            profile: {
                email: settings.user_email,
            },
        },
        paymentType: 'CARD',
        accountId: settings.account_id,
    };

    if (customer_single_use_token && options.use_single_use_customer_token) {
        tokenizationOptions.singleUseCustomerToken = customer_single_use_token;
    }
    if (customer_single_use_token && options.payment_toke_from) {
        tokenizationOptions.paymentTokenFrom = options.payment_toke_from;
    }

    if (settings.merchant_descriptor && settings.merchant_phone) {
        tokenizationOptions.merchantDescriptor = {
            dynamicDescriptor: settings.merchant_descriptor,
            phone: settings.merchant_phone,
        }
    }

    tokenizationOptions.customerDetails = {
        holderName: customer.firstName + ' ' + customer.lastName,
        billingDetails: {
            nickName: "Home",
            zip: billing_address.billing_zip,
            country: billing_address.billing_country,
        },
        profile: {
            firstName: customer.firstName,
            lastName: customer.lastName,
            email: customer.email,
            locale: settings.locale,
            phone: billing_address.billing_phone,
        }
    };

    if (options.customerDetails && options.customerDetails.holderName) {
        if (options.customerDetails.holderName) {
            tokenizationOptions.customerDetails.holderName = options.customerDetails.holderName;
        }
    }

    if (billing_address.billing_street) {
        tokenizationOptions.customerDetails.billingDetails.street = billing_address.billing_street;
    }
    if (billing_address.billing_street2) {
        tokenizationOptions.customerDetails.billingDetails.street2 = billing_address.billing_street2;
    }
    if (billing_address.billing_city) {
        tokenizationOptions.customerDetails.billingDetails.city = billing_address.billing_city;
    }
    if (billing_address.billing_state) {
        tokenizationOptions.customerDetails.billingDetails.state = billing_address.billing_state;
    }
    if (billing_address.billing_phone) {
        tokenizationOptions.customerDetails.billingDetails.phone = billing_address.billing_phone;
    }

    hostedPaymentInstance
        .tokenize(tokenizationOptions)
        .then(result => {
            if (!result || !result.token) {
                let error_message = '';
                if (result && result.error) {
                    error_message += result.error.message ? result.error.message : result.error;
                }
                if (result && result.error_message) {
                    error_message += result.error_message;
                }

                // log payment fail
                log_order_payment_failure(
                    log_order_fail_endpoint,
                    order_id,
                    error_message
                );

                throw 'Result failure';
            }

            const paymentData = {
                orderId: order_id,
                paymentMethod: 'CARD',
                transactionType: 'PAYMENT',
                paymentHandleToken: result.token,
                amount: payment_amount,
                customerOperation: '',
                merchantRefNum: merch_ref_num,
                nonce: settings.nonce,
            };

            if (!!options.save_card) {
                paymentData.save_card = true;
            }

            const safe_path = validate_paysafe_safe_path(settings.register_url);
            fetch(
                safe_path,
                {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                    }),
                    body: JSON.stringify(paymentData),
                })
                .then(result => {
                    return result.json();
                })
                .then(json => {
                    if (json.status === 'error' || json.error_message) {
                        // log payment fail
                        log_order_payment_failure(
                            log_order_fail_endpoint,
                            order_id,
                            json.error_message
                        );

                        log_paysafe_error(log_error_endpoint, json.error_message, {'tokenization_stage': 1});
                        show_paysafe_checkout_error(json.error_message);
                        show_paysafe_checkout_error(__('The payment process failed. Please reload the page and try again', 'paysafe-checkout'), true);
                    } else {
                        window.location = json.redirect_url;
                    }
                })
                .catch((error) => {
                    let errorMessage = get_paysafe_error_message(error);

                    // log payment fail
                    log_order_payment_failure(
                        log_order_fail_endpoint,
                        order_id,
                        errorMessage
                    );

                    // the BE call failed
                    const error_message = 'ERROR ' + error.code + ': ' + error.detailedMessage;
                    log_paysafe_error(log_error_endpoint, error_message, []);
                    show_paysafe_checkout_error(error_message);
                    show_paysafe_checkout_error(__("The payment process failed. Please reload the page and try again", "paysafe-checkout"), true);
                });
        })
        .catch(error => {
            let errorMessage = get_paysafe_error_message(error);

            // log payment fail
            log_order_payment_failure(
                log_order_fail_endpoint,
                order_id,
                errorMessage
            );

            // this means that the tokenization of the card form failed,
            // disable this payment method, show the error and refresh the page in 15 seconds
            const error_message = 'ERROR ' + error.code + ': ' + error.detailedMessage;
            log_paysafe_error(log_error_endpoint, error_message, []);
            show_paysafe_checkout_error(error_message);
            show_paysafe_checkout_error(__('The payment process failed. Please reload the page and try again', 'paysafe-checkout'), true);
        });
}

export function init_paysafe_fields(settings, paysafe_options, current_cart_data, just_return_error_on_error = false) {
    // initialize the hosted iframes using the SDK setup function
    const log_error_endpoint = settings.log_errors === true ? (settings.log_error_endpoint || null) : null;

    return paysafe.fields
        .setup(
            settings.authorization,
            paysafe_options
        )
        .then(instance => {
            return instance.show().then(paymentMethods => {
                if (paymentMethods.card && !paymentMethods.card.error) {
                    // When the customer clicks Pay Now,
                    // call the SDK tokenize function to create
                    // a single-use payment token corresponding to the card details entered

                    return instance;
                }
                if (paymentMethods.applePay && !paymentMethods.applePay.error) {
                    return instance;
                }
                if (paymentMethods.googlePay && !paymentMethods.googlePay.error) {
                    return instance;
                }
            });
        })
        .catch(error => {
            if (error.error) {
                error = error.error;
            }

            if (!just_return_error_on_error) {
                // this means that the initialization of the form failed,
                // disable this payment method
                const error_message = 'ERROR ' + error.code + ': ' + error.detailedMessage;

                const error_context = get_paysafe_js_setup_error_context(
                    error,
                    settings,
                    paysafe_options,
                    current_cart_data
                );
                log_paysafe_error(log_error_endpoint, error_message, error_context);
                show_paysafe_checkout_error(error_message);
            }

            return Promise.reject(error);
        });
}

export function log_order_payment_failure(log_order_fail_endpoint, order_id, reason) {
    if (!reason) {
        return;
    }

    if (log_order_fail_endpoint) {
        const endpoint = new URL(log_order_fail_endpoint, window.location.origin);

        if (endpoint.origin !== window.location.origin) {
            return;
        }

        fetch(
            // nosemgrep
            endpoint.pathname + endpoint.search,
            {
                method: 'POST',
                credentials: 'same-origin',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
                body: JSON.stringify({
                    order_id: order_id,
                    reason: reason,
                    nonce: _log_nonce,
                }),
            })
            .catch(() => {});
    }
}

export function get_paysafe_error_message(error) {
    let error_message = '';
    if (error) {
        if (error.code) {
            error_message += error.code + ' ';
        }
        if (error.message) {
            error_message += error.message + ' ';
        }
        if (error.detailedMessage) {
            error_message = error.detailedMessage;
        }
        if (error.displayMessage) {
            error_message = error.displayMessage;
        }
    }

    return error_message;
}
